import * as types from "../types";

const initialState = {
  badges: null,
  listLoading: false,
  errorList: null,
};

export const badges = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_BADGES_REQUEST:
      return {
        ...state,
        listLoading: true,  
        errorList: null,
      };
    case types.GET_BADGES_SUCCESS:
      return {
        ...state,
        listLoading: false,
        badges: action.payload,
      };
    case types.GET_BADGES_FAIL:
      return {
        ...state,
        listLoading: false,
        errorList: action.payload,
      };
    default:
      return state;
  }
};
